import { render } from "./defectList.vue?vue&type=template&id=25d8ed9b&scoped=true&ts=true"
import script from "./defectList.vue?vue&type=script&lang=ts"
export * from "./defectList.vue?vue&type=script&lang=ts"

import "./defectList.vue?vue&type=style&index=0&id=25d8ed9b&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d8ed9b"]])

export default __exports__